Pegasus.ViewOptionsController = Em.Controller.extend({
  needs: ['template'],
  isStandaloneBinding: Em.Binding.oneWay('controllers.template.isStandalone'),
  documentHasRelativeRepresentation: function(){
    var relativeOptionsAvailable = this.get('isSendTestEnabled') || this.get('isTestKitEnabled'),
      relativeRepresentationAvailable = Pegasus.EmailTemplate.detectInstance( this.get('controllers.template.content') );

    return relativeRepresentationAvailable && relativeOptionsAvailable;
  }.property('controllers.template.content', 'isSendTestEnabled', 'isTestKitEnabled'),
  zoomValue: 100,
  incrementZoomValue: function(){
    if ( this.get('zoomValue') === 100 ) { return; }
    this.set('zoomValue', this.get('zoomValue') + 10 );
  },
  decrementZoomValue: function(){
    if ( this.get('zoomValue') === 10 ) { return; }
    this.set('zoomValue', this.get('zoomValue') - 10 );
  },
  isHelpEnabled: function(){
    return Pegasus.get('options.isHelpEnabled');
  }.property('Pegasus.options.isHelpEnabled'),
  isFeedbackEnabled: function(){
    return Pegasus.get('options.isFeedbackEnabled');
  }.property('Pegasus.options.isFeedbackEnabled'),
  isSendTestEnabled: function(){
    return Pegasus.get('options.isSendTestEnabled');
  }.property('Pegasus.options.isSendTestEnabled'),
  isTestKitEnabled: function(){
    return Pegasus.get('options.isTestKitEnabled');
  }.property('Pegasus.options.isTestKitEnabled')
});
